const API_URL = process.env.REACT_APP_API_URL || '';

const FIELD_MAP = {
  equipoId: 'equipo_id',
  ticketId: 'ticket_id',
  fotoRemito: 'remito_foto',
  created_at: 'created_at',
};
const REVERSE_MAP = Object.fromEntries(Object.entries(FIELD_MAP).map(([k, v]) => [v, k]));

function mapFields(obj, reverse = false) {
  if (!obj || typeof obj !== 'object') return obj;
  const map = reverse ? REVERSE_MAP : FIELD_MAP;
  const mapped = {};
  for (const [k, v] of Object.entries(obj)) {
    mapped[map[k] || k] = v;
  }
  return mapped;
}

function toFormData(data) {
  if (!data) return '';
  return Object.entries(data).map(([k, v]) =>
    encodeURIComponent(k) + '=' + encodeURIComponent(typeof v === 'object' ? JSON.stringify(v) : String(v))
  ).join('&');
}

async function req(method, path, data) {
  const opts = { method, headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, credentials: 'include' };
  if (data) opts.body = toFormData(data);
  const res = await fetch(`${API_URL}/backend/${path}`, opts);
  const json = await res.json();
  if (!res.ok) throw new Error(json.error || 'Error');
  return json;
}

async function tieneSesion() {
  try { await req('GET', 'verificar.php'); return true; } catch { return false; }
}

export async function syncAllToBackend() {
  if (!(await tieneSesion())) {
    console.warn('⏭️ No hay sesión PHP activa, omitiendo sync');
    return [];
  }

  const tables = [
    { key: 'medtrack_equipos', list: 'equipos.php', create: 'equipos.php', update: 'equipos.php' },
    { key: 'medtrack_tickets', list: 'tickets.php', create: 'tickets.php', update: 'tickets.php' },
    { key: 'medtrack_diagnosticos', list: 'diagnosticos.php', create: 'diagnosticos.php', update: 'diagnosticos.php' },
    { key: 'medtrack_presupuestos', list: 'presupuestos.php', create: 'presupuestos.php', update: 'presupuestos.php' },
    { key: 'medtrack_repuestos', list: 'inventario.php', create: 'inventario.php', update: 'inventario.php' },
    { key: 'medtrack_usuarios', list: 'usuarios.php', create: 'usuarios.php', update: 'usuarios.php', matchBy: 'email' },
  ];
  const results = [];
  for (const table of tables) {
    try {
      const stored = JSON.parse(localStorage.getItem(table.key) || '[]');
      if (stored.length === 0) continue;
      const existing = await req('GET', table.list);
      const existingArr = existing.data || existing || [];
      const existingIds = new Set(existingArr.map(x => String(x.id)));
      const existingByMatch = table.matchBy ? new Map(existingArr.map(x => [x[table.matchBy], x])) : null;
      let created = 0, updated = 0;
      for (const item of stored) {
        try {
          if (table.key === 'medtrack_presupuestos' && (item.estado === 'Aprobado' || item.estado === 'Rechazado')) continue;
          const payload = mapFields(item);
          let match;
          if (existingByMatch) {
            match = existingByMatch.get(item[table.matchBy]);
          }
          if (match) {
            if (table.update) { await req('PUT', table.update, { ...payload, id: match.id }); updated++; }
          } else if (existingIds.has(String(item.id))) {
            if (table.update) { await req('PUT', table.update, payload); updated++; }
          } else {
            if (table.create) { await req('POST', table.create, payload); created++; }
          }
        } catch (e) {
          console.warn(`⚠️ Error en ${table.key}: ${e.message}`);
        }
      }
      results.push({ table: table.key, created, updated });
    } catch (e) {
      console.warn(`⚠️ Error listing ${table.key}: ${e.message}`);
      results.push({ table: table.key, error: e.message });
    }
  }
  return results;
}

export async function loadAllFromBackend() {
  const endpoints = [
    { key: 'medtrack_equipos', path: 'equipos.php' },
    { key: 'medtrack_tickets', path: 'tickets.php' },
    { key: 'medtrack_diagnosticos', path: 'diagnosticos.php' },
    { key: 'medtrack_presupuestos', path: 'presupuestos.php' },
    { key: 'medtrack_repuestos', path: 'inventario.php' },
    { key: 'medtrack_usuarios', path: 'usuarios.php' },
    { key: 'medtrack_bitacora_reparacion', path: 'reparacion.php?tipo=bitacora' },
    { key: 'medtrack_auditorias', path: 'auditorias.php' },
    { key: 'medtrack_movimientos_stock', path: 'reparacion.php?tipo=movimientos' },
    { key: 'medtrack_historial_equipos', path: 'reparacion.php?tipo=historial' },
  ];
  let anyLoaded = false;
  for (const ep of endpoints) {
    try {
      const res = await req('GET', ep.path);
      const items = res.data || res || [];
      if (Array.isArray(items) && items.length > 0) {
        localStorage.setItem(ep.key, JSON.stringify(items.map(i => mapFields(i, true))));
        anyLoaded = true;
      }
    } catch {}
  }
  return anyLoaded;
}

export { req };

export async function apiLogin(email, password) {
  const res = await req('POST', 'login.php', { email, password });
  return res.usuario || null;
}

export async function apiLoginGet(email, password) {
  const res = await fetch(`/backend/login.php?email=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}`, { credentials: 'include' });
  const json = await res.json();
  if (!res.ok) throw new Error(json.error || 'Error');
  return json.usuario || null;
}

export async function apiLogout() {
  await req('POST', 'logout.php').catch(() => {});
}
